import { errorToast, warnToast } from "../utils/toast";
import { Exception, Warn } from "@sieg-ad/error";

export type ApiErrorType = 'error' | 'warn';

export class CustomError extends Exception {
  constructor(message: string = 'Erro interno da aplicação', code: string = 'DEMERR', status: number = 500) {
    super(code, message, status);

    console.error(message);
    errorToast(message);
  }
}

export class  CustomWarn extends Warn {
  constructor(message: string = 'Aviso interno da aplicação', code: string = 'DEMWARN', status: number = 400) {
    super(code, message, status);

    warnToast(message);
    console.warn(message);
  }
}

export class AbortError extends Exception {
  redirect: string;

  constructor(message: string, redirect: string = '/') {
    super('ABORTERR', message, 500);
    this.redirect = redirect;
  }
}